import React from "react";
import { useLanguage } from "@/lib/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <section data-testid="marquee-section" className="border-y border-eh-border bg-eh-cream overflow-hidden">
      <div className="py-7 whitespace-nowrap flex">
        <div className="marquee-track flex gap-14 pr-14">
          {items.map((w, i) => (
            <span
              key={i}
              className="font-display italic text-3xl md:text-4xl text-eh-ink/70 inline-flex items-center gap-14"
            >
              {w}
              <span className="text-eh-sage-deep">✺</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
